import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { UserContext } from "./UserContext";
import { appConfig } from "../../../configuration/AppConfig";

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const PrivateRoute = ({ component: Component, role, ...rest }) => {
  const { user, isSyncing } = useContext(UserContext);
  const v2AuthCookie = getCookie("v2Authenticated");

  if (!role && !sessionStorage.auth && v2AuthCookie !== "true") {
    sessionStorage.setItem("route", window.location.pathname);
    sessionStorage.setItem("auth", "false");
    window.location.assign(`${appConfig.authEndpoint}${appConfig.authParams}`);
    return <span>Checking User ...</span>;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isSyncing) {
          return (
            <div className="utah-id-syncing">
              <p><em>Checking Login Status...</em></p>
            </div>
          );
        }

        const isAuthenticated = user && !user.isDefault;
        const hasRequiredRole = role !== undefined ? role : true;

        if (isAuthenticated && hasRequiredRole) {
          return <Component {...props} />;
        }

        return (
          <Redirect 
            to={{ 
              pathname: "/not-authorized", 
              state: { from: props.location } 
            }} 
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
